(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AuthCustom', AuthCustom);

    AuthCustom.$inject = ['$resource', 'ENV'];

    function AuthCustom($resource, ENV) {

        var sendActivationCode = function (phoneNumber) {


            var resourceUrl = ENV.API_BASE_URL + 'api/client/resetPassword/sendActivationCode/' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'get': {
                        method: 'GET',
                        transformResponse: function (data) {
                            if (data) {
                                data = angular.fromJson(data);
                            }
                            return data;
                        }
                    }
                }
            );
        };


        return {
            sendActivationCode: sendActivationCode
        }
    }
})();
